import { useState, useEffect } from 'react';
import { Badge, Card, Carousel, CustomModal, Typography } from 'seagull';
import { useIoContext, useStoreActions } from "../../../../contexts";
import styles from "./TutorialVideosModal.module.scss";
import { useTutorialVideos } from "../../../../hooks/useTutorialVideos/useTutorialVideos";
import cn from 'classnames';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const VideoCardItem = _ref => {
  let {
    video,
    onSelect,
    isActive
  } = _ref;
  const {
    id,
    title,
    watched,
    duration
  } = video;
  const {
    YoutubePlayer
  } = useIoContext();
  return /*#__PURE__*/_jsx("div", {
    className: styles.VideoItemContainer,
    children: /*#__PURE__*/_jsxs(Card, {
      className: cn(styles.VideoItemCard, {
        [styles.played]: isActive
      }),
      "data-testid": "tutorial-video-".concat(video.id),
      as: "button",
      highlightOnHover: true,
      onClick: () => onSelect(video),
      children: [/*#__PURE__*/_jsx(YoutubePlayer, {
        className: styles.thumbnail,
        controls: false,
        playIcon: /*#__PURE__*/_jsx(_Fragment, {}),
        width: "164px",
        height: "100px",
        light: true,
        url: "https://youtu.be/".concat(id)
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          weight: "bold",
          className: styles.videoTitle,
          "data-testid": "tutorial-video-title",
          children: title
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.durationRow,
          children: [/*#__PURE__*/_jsx(Typography, {
            className: styles.videoDuration,
            variant: "paragraph2",
            weight: "light",
            "data-testid": "tutorial-video-duration",
            children: "".concat(duration, " min")
          }), watched && /*#__PURE__*/_jsx(Badge, {
            rounded: true,
            outlined: true,
            skin: "success",
            size: "default",
            "data-testid": "tutorial-video-watched-tag",
            children: "Watched"
          })]
        })]
      })]
    })
  });
};
export default function TutorialVideosModal(_ref2) {
  let {
    dismissModal
  } = _ref2;
  const {
    videos,
    handleWatch
  } = useTutorialVideos();
  const {
    YoutubePlayer
  } = useIoContext();
  const {
    logBI
  } = useStoreActions();
  const [currentVideo, setCurrentVideo] = useState(null);
  useEffect(() => {
    if (videos.length > 0 && !currentVideo) {
      setCurrentVideo(videos[0]);
    }
  }, [currentVideo, videos]);
  const videoSlider = /*#__PURE__*/_jsx(Carousel, {
    itemWidth: 180,
    children: videos.map(video => /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(VideoCardItem, {
        video: video,
        onSelect: setCurrentVideo,
        isActive: (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.id) === video.id
      })
    }, video.id))
  });
  return /*#__PURE__*/_jsx(CustomModal, {
    className: styles.TutorialVideosModal,
    maxWidth: "100% - 32px",
    maxHeight: "100% - 32px",
    style: {
      aspectRatio: '12 / 11'
    },
    onClose: () => {
      if (currentVideo) {
        logBI(11216, {
          videoId: currentVideo.id,
          title: currentVideo.title
        });
      }
      dismissModal();
    },
    headerClassName: styles.modalTitle,
    header: /*#__PURE__*/_jsx(Typography, {
      weight: "bold",
      "data-testid": "tutorial-videos-modal-title",
      children: "Explore tutorials"
    }),
    children: /*#__PURE__*/_jsx("div", {
      className: styles.modalContent,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.modalMediaWrapper,
        children: [currentVideo && /*#__PURE__*/_jsx(YoutubePlayer, {
          className: styles.responsivePlayer,
          height: "100%",
          width: "auto",
          controls: true,
          url: "https://youtu.be/".concat(currentVideo.id),
          "data-testid": "tutorial-played-video",
          onStart: () => {
            if (!currentVideo.watched) {
              handleWatch(currentVideo);
            }
            logBI(11215, {
              videoId: currentVideo.id,
              title: currentVideo.title
            });
          }
        }), /*#__PURE__*/_jsx("div", {
          className: styles.modalVideosSliderContainer,
          children: videoSlider
        })]
      })
    })
  });
}